import React from 'react';
import { Box, IconButton, Typography, CircularProgress } from '@mui/material';
import { ArrowBack } from 'components/icons';

interface HeaderSectionProps {
	isNewParkingLocation: boolean;
	onClose: () => void;
	loading: boolean;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
	isNewParkingLocation,
	onClose,
	loading,
}) => {
	return (
		<Box display="flex" alignItems="center" gap={1}>
			<IconButton
				onClick={onClose}
				sx={{
					display: {
						xs: 'block',
						sm: 'none',
					},
				}}
			>
				<ArrowBack />
			</IconButton>
			<Typography variant="h6" fontWeight={300}>
				{isNewParkingLocation
					? 'Create New Parking Location'
					: 'Edit Parking Location'}
			</Typography>
			{loading && <CircularProgress size={24} />}
		</Box>
	);
};

export default HeaderSection;
